export const counties = ['Narok', 'Kajiado', 'Samburu', 'Laikipia'];
